import { CalendarOutlined, FieldTimeOutlined } from '@ant-design/icons'
import { Button, Card, Col, Row } from 'antd'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { EmptyText, WordBreak } from '../../components/Common/CellText'
import FileItem from '../../components/Common/FileItemComponent/FileItem'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  DATE_FORMAT_DEFAULT,
  HHhMM,
} from '../../constants'
import utils from '../../utils'
import React from 'react'
import AccessControlAction from '../../components/AccessControlAction'
import { toJS } from 'mobx'

export const OfficeCalendarEventDetailItem = props => {
  const { label, value } = props || {}

  return (
    <div>
      <p
        style={{
          marginBottom: 4,
          fontSize: 12,
          fontWeight: 400,
          color: '#1D2630',
          opacity: 0.7,
        }}>
        {label}
      </p>
      <div
        style={{
          fontSize: 14,
          fontWeight: 500,
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          whiteSpace: 'pre-wrap',
        }}>
        {value}
      </div>
    </div>
  )
}

export const OfficeCalendarEventDetail = props => {
  const { workScheduleDetail, onDeleteEvent, onEditEvent } = props || {}

  const history = useHistory()

  const showPersonAndDate = (person, date) => {
    if (person) {
      return (
        <div>
          {`${utils.getNameInCapitalize(person)} - `}
          <span>{moment(date).format(DATE_FORMAT_DEFAULT)}</span>&nbsp;
          <span>{moment(date).format(HHhMM)}</span>
        </div>
      )
    }
    return <EmptyText>Chưa có thông tin</EmptyText>
  }

  const recipientNoticeList =
    workScheduleDetail?.assignees &&
    toJS(workScheduleDetail?.assignees).filter(
      el => el.permission === ASSIGNEE_TYPE.FOLLOWER
    )

  if (!workScheduleDetail) return null

  return (
    <>
      <div
        style={{
          display: 'flex',
          gap: 24,
          marginBottom: 40,
        }}>
        <Card
          style={{
            flex: 1,
            background: '#F7F7F7',
            border: 'none',
            borderRadius: 16,
            minWidth: 0,
          }}
          bodyStyle={{ padding: 20 }}>
          <h2
            style={{
              marginBottom: 16,
              fontSize: 18,
              fontWeight: 600,
            }}>
            Thông tin chung
          </h2>

          <Row gutter={[20, 20]}>
            <Col span={8}>
              <OfficeCalendarEventDetailItem
                label="Ngày thực hiện"
                value={
                  workScheduleDetail?.start_at ? (
                    <>
                      <CalendarOutlined style={{ marginRight: 4 }} />
                      <span>
                        {moment(workScheduleDetail?.start_at).format(
                          DATE_FORMAT_DEFAULT
                        )}
                      </span>
                    </>
                  ) : (
                    <EmptyText>Không rõ.</EmptyText>
                  )
                }
              />
            </Col>
            <Col span={8}>
              <OfficeCalendarEventDetailItem
                label="Thời gian bắt đầu"
                value={
                  workScheduleDetail?.start_at ? (
                    <>
                      <FieldTimeOutlined style={{ marginRight: 4 }} />
                      <span>
                        {moment(workScheduleDetail?.start_at).format(HHhMM)}
                      </span>
                    </>
                  ) : (
                    <EmptyText>Không rõ.</EmptyText>
                  )
                }
              />
            </Col>
            <Col span={8}>
              <OfficeCalendarEventDetailItem
                label="Thời gian kết thúc"
                value={
                  workScheduleDetail?.end_at ? (
                    <>
                      <FieldTimeOutlined style={{ marginRight: 4 }} />
                      <span>
                        {moment(workScheduleDetail?.end_at).format(HHhMM)}
                      </span>
                    </>
                  ) : (
                    <EmptyText>Không rõ.</EmptyText>
                  )
                }
              />
            </Col>

            <Col span={8}>
              <OfficeCalendarEventDetailItem
                label="Chủ trì"
                value={
                  workScheduleDetail?.host || <EmptyText>Không rõ.</EmptyText>
                }
              />
            </Col>
            <Col span={8}>
              <OfficeCalendarEventDetailItem
                label="Địa điểm"
                value={
                  workScheduleDetail?.location ? (
                    WordBreak(utils.urlify(workScheduleDetail?.location), true)
                  ) : (
                    <EmptyText>Không rõ.</EmptyText>
                  )
                }
              />
            </Col>
            <Col span={8}>
              <OfficeCalendarEventDetailItem
                label="Chuẩn bị"
                value={
                  workScheduleDetail?.preparation ? (
                    WordBreak(
                      utils.urlify(workScheduleDetail?.preparation),
                      true
                    )
                  ) : (
                    <EmptyText>Không có chuẩn bị.</EmptyText>
                  )
                }
              />
            </Col>

            <Col span={16}>
              <OfficeCalendarEventDetailItem
                label="Tài liệu đính kèm"
                value={
                  workScheduleDetail.file_ids?.length ? (
                    workScheduleDetail.file_ids.map(file => (
                      <FileItem
                        key={file.file_id}
                        file_id={file.file_id}
                        file_name={file.file_title}
                        file_type={utils.getExtensionFile(file.file_title)}
                      />
                    ))
                  ) : (
                    <EmptyText>Không có tài liệu đính kèm.</EmptyText>
                  )
                }
              />
            </Col>
            <Col span={8}>
              <OfficeCalendarEventDetailItem
                label="Thành viên tham gia"
                value={
                  workScheduleDetail?.attenders ? (
                    workScheduleDetail?.attenders
                  ) : (
                    <EmptyText>Không có thành viên tham gia.</EmptyText>
                  )
                }
              />
            </Col>

            <Col span={24}>
              <OfficeCalendarEventDetailItem
                label="Nội dung sự kiện"
                value={
                  workScheduleDetail?.event_notice ? (
                    WordBreak(workScheduleDetail?.event_notice, true)
                  ) : (
                    <EmptyText>Không có nội dung sự kiện.</EmptyText>
                  )
                }
              />
            </Col>
          </Row>
        </Card>

        <Card
          style={{
            width: 372,
            background: '#F7F7F7',
            border: 'none',
            borderRadius: 16,
          }}
          bodyStyle={{ padding: 20 }}>
          <h3
            style={{
              marginBottom: 16,
              fontSize: 18,
              fontWeight: 600,
            }}>
            Thông tin khác
          </h3>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 20,
            }}>
            <OfficeCalendarEventDetailItem
              label="Thông báo"
              value={
                recipientNoticeList?.length > 0 ? (
                  <span>
                    {recipientNoticeList
                      ?.map(el => utils.getNameInCapitalize(el.name_uppercase))
                      .join(', ')}
                  </span>
                ) : (
                  <EmptyText>Không có người nhận thông báo.</EmptyText>
                )
              }
            />

            <OfficeCalendarEventDetailItem
              label="Ngày tạo"
              value={showPersonAndDate(
                workScheduleDetail?.assignees?.find(
                  user => user.permission === ASSIGNEE_TYPE.CREATE
                )?.name_uppercase,
                workScheduleDetail?.created_at
              )}
            />

            <OfficeCalendarEventDetailItem
              label="Chỉnh sửa lần cuối"
              value={showPersonAndDate(
                workScheduleDetail?.last_edit_by?.name_lowercase,
                workScheduleDetail?.updated_at
              )}
            />
          </div>
        </Card>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 16,
        }}>
        <AccessControlAction
          aclActionType={ACL_ACTION_TYPE.delete__WORK_SCHEDULE}>
          <Button
            danger
            className="w-160"
            onClick={() => onDeleteEvent(workScheduleDetail?.schedule_code)}>
            Xóa
          </Button>
        </AccessControlAction>
        <AccessControlAction
          aclActionType={ACL_ACTION_TYPE.edit__WORK_SCHEDULE}>
          <Button
            type="primary"
            className="w-160"
            onClick={() => onEditEvent(workScheduleDetail?.schedule_code)}>
            Chỉnh sửa
          </Button>
        </AccessControlAction>
      </div>
    </>
  )
}
